// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"277bd01d","361":"c237ea0b","774":"04af248d","919":"c40ac724"}[chunkId] + ".chunk.js";
};